import Sidebar from "../Common/Sidebar";
import { useState } from "react";
import { Card } from "primereact/card";
import folders from "../assets/images/folders.png";

export default function Os165LandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [pagename, setPageName] = useState("os165");

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };

  const folderStructure = [
    {
      name: "Servicing",
      contents: [
        "https://drive.google.com/drive/u/0/folders/1Dub7WkmCuvPdOaQdoTKgyQ51j36Cl9Mi",
      ],
    },
    {
      name: "Sales",
      contents: [
        "https://drive.google.com/drive/u/0/folders/1yCmDoLnY26tQK2FJ6usWlF21w68fvW75",
      ],
    },
    {
      name: "Quote/Rate/Bind",
      contents: [
        "https://drive.google.com/drive/u/0/folders/1Rp2jxVJbvINvUG8vnj9e77hlU7WsDaEO",
      ],
    },
    {
      name: "Operations",
      contents: [
        "https://drive.google.com/drive/u/0/folders/1zVZs7EbDYm500MDDmoSeVAvhPjKke2-D",
      ],
    },
    {
      name: "Management/Reporting",
      contents: [
        "https://drive.google.com/drive/u/0/folders/15RrYDMlWrNX_0qqOXCIW4RnbfR0qsqYZ",
      ],
    },
    {
      name: "Finance & Accounting",
      contents: [
        "https://drive.google.com/drive/u/0/folders/1c6uDO1kNoEV4duPC-kdMoC2Q_ecNticK",
      ],
    },
  ];

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename={pagename}
        setPageName={setPageName}
        onSidebarValueChanged={onSidebarValueChanged}
      />
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div
          className={`${
            showWideSidebar ? "main-content-large-width" : "main-content-small-width"
          }`}
        >
          <div>
            <h2 className="fw-bold">OS 165</h2>
          </div>
          <Card className="mt-4 p-4">
            <div className="row folder-grid">
              {folderStructure.map((folder) => (
                <div
                  key={folder.name}
                  className="col-md-3 mb-4"
                  style={{ cursor: "pointer" }}
                  onClick={() => window.open(folder.contents[0], "_blank")}
                >
                  <div className="folder-card">
                    <img src={folders} alt="Folder" className="folder-img" />
                    <h6 className="folder-title">{folder.name}</h6>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
